import React, {Component} from 'react';
import {ajax} from '../../Context';
import Headline from '../Elements/Headline/Headline';
import Footer from "../Footer/Footer";
import './Profile.css';
import Spinner from "../Elements/Spinner/Spinner";

const AJAX_TYPE = '135798';

class Profile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data:null
        };

    }

    componentDidMount() {
        fetch(ajax.url + '?type=' + AJAX_TYPE + '&uhash=' + this.props.hash)
            .then(response => response.json())
            .then(data => this.setState({data}));
    }

    render() {
        if(this.state.data) {
            return (
                <div>
                    <Headline brand="primary" label="Mein Konto" tag="h1" />
                    <br />
                    <p>IHRE ANGABEN</p>
                    <p><strong>Benutzername / E-Mail-Adresse:</strong><br />
                    {this.state.data.username}</p>
                    <br />
                    <p><strong>Passwort</strong><br />
                    ************</p>
                    <p>Sie möchten Ihre Angaben ändern?<br />
                    Dann wechseln Sie bitte zur Website des Extranets.</p>
                    <a href="https://novoferm-extranet.de" className="btn btn-primary" target="_blank" rel="noopener noreferrer">Zur Website</a>
                    <div>
                        <button type="button" className="logout-button btn btn-default" title="Logout" onClick={this.props.logoutUser}>
                            Abmelden
                        </button>
                    </div>
                    <Footer route={this.state.route} changeRoute={this.changeRoute} hash={this.state.hash} />
                </div>
            )
        }else{
            return (
                <Spinner message="" />
            )
        }

    }
}

export default Profile;


// WEBPACK FOOTER //
// ./src/Components/Profile/Profile.js